import { render, staticRenderFns } from "./ModalGroupAccept.vue?vue&type=template&id=0fc6d903&scoped=true"
import script from "./ModalGroupAccept.vue?vue&type=script&lang=js"
export * from "./ModalGroupAccept.vue?vue&type=script&lang=js"
import style0 from "./ModalGroupAccept.vue?vue&type=style&index=0&id=0fc6d903&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc6d903",
  null
  
)

export default component.exports